import React from 'react';
import { useEstabsContext } from '../../contexts/EstabsContext';
import { useAppContext } from '../../contexts/AppContext';
import './Clientes.css';
import { Copy, Mail, MessageCircle, Share } from 'lucide-react';

export const ShareAgenda: React.FC = () => {
    const { estabSession } = useEstabsContext();
    const { successSnackbar, errorSnackbar } = useAppContext();
    const shareUrl = `${window.location.origin}/login?estabId=${estabSession._id}`;
    const shareText = `Olá! Confira minha agenda em: ${shareUrl}`;
    const canUseNativeShare = typeof navigator.share === 'function';

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(shareUrl);
            successSnackbar('Link copiado!');
        } catch (err) {
            errorSnackbar('Erro ao copiar link');
        }
    };

    const handleNativeShare = async () => {
        try {
            await navigator.share({ title: 'Confira minha agenda!', url: shareUrl });
        } catch (err) {
            // Fechar a folha de compartilhamento tambem rejeita a promessa; nao e erro para o usuario.
        }
    };

    return (
        <div className="space-y-2">
            <div className="sf-group">
                {canUseNativeShare && (
                    <button type="button" className="cli-share-row" onClick={handleNativeShare}>
                        <Share aria-hidden />
                        Compartilhar...
                    </button>
                )}
                <button type="button" className="cli-share-row" onClick={handleCopyLink}>
                    <Copy aria-hidden />
                    Copiar link
                </button>
                <a
                    className="cli-share-row"
                    href={`https://wa.me/?text=${encodeURIComponent(shareText)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <MessageCircle aria-hidden />
                    Enviar pelo WhatsApp
                </a>
                <a
                    className="cli-share-row"
                    href={`mailto:?subject=${encodeURIComponent('Confira minha agenda!')}&body=${encodeURIComponent(shareText)}`}
                >
                    <Mail aria-hidden />
                    Enviar por e-mail
                </a>
            </div>
            <p className="break-all px-4 text-xs text-base-content/55">{shareUrl}</p>
        </div>
    );
};
